import * as types from '../actiontypes';
import Env from '../../util/env';
import { serviceURL, projectRoutes } from '../../util/uiconstants';

export function getOrgChart(projectId, payload) {
	let url = payload?.isContactsPage ? `${getProjectUrl(projectId)}${projectRoutes.contacts}` :
	 `${getProjectUrl(projectId)}${projectRoutes.entities}`;

	return {
		type: types.GET_ORG_CHART,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		},
		payload,
	};
}

export function setOrgChart(orgChart) {
	return {
		type: types.SET_ORG_CHART,
		orgChart: orgChart
	};
}

export function getQuickFilters(projectId) {
	return {
		type: types.GET_QUICK_FILTERS,
		meta: {
			api: {
				url: getFiltersUrl(projectId),
				method: 'GET'
			}
		}
	};
}

export function addQuickFilter(projectId, body, name, selectedNodes) {
	return {
		type: types.ADD_QUICK_FILTERS,
		name: name,
		selectedNodes: selectedNodes,
		meta: {
			api: {
				url: getFiltersUrl(projectId),
				data: body,
				method: 'POST'
			}
		}
	};
}

export function editQuickFilter(projectId, filterId, quickFilterId, name, selectedNodes, body) {
	return {
		type: types.EDIT_QUICK_FILTERS,
		name: name,
		filterId: filterId,
		selectedNodes: selectedNodes,
		meta: {
			api: {
				url: `${getFiltersUrl(projectId)}${filterId}`,
				data: {
					...body,
					quickFilterId: quickFilterId
				},
				method: 'PUT'
			}
		}
	};
}

export function deleteQuickFilter(projectId, filterId, quickFilterId) {
	return {
		type: types.DELETE_QUICK_FILTERS,
		filterId: filterId,
		meta: {
			api: {
				url: `${getFiltersUrl(projectId)}${filterId}?quickFilterId=${quickFilterId}`,
				method: 'DELETE'
			}
		}
	};
}

export function resetNewFlag() {
	return {
		type: types.RESET_NEW_FLAG
	};
}

const getFiltersUrl = (projectId) => `${getProjectUrl(projectId)}${projectRoutes.filters}/`;
const getProjectUrl = (projectId) => `${Env.getBaseURL(serviceURL)}Projects/${projectId}/`;
